"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Anomaly extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'anomaly';
        this._startTs = initParams.start_ts;
        this._endTs = initParams.end_ts;
        this._deviceId = initParams.device_id;
        this._deviceName = initParams.device_name;
        this._siteId = initParams.site_id;
        this._modelId = initParams.model_id;
        this._siteName = initParams.site_name;
        this._explanation = initParams.explanation;
        this._notes = initParams.notes;
        this._userStatus = initParams.user_status;
        this._dismissed = initParams.dismissed;
        this._invalid = initParams.invalid;
        this._modelImageUrl = initParams.model_image_url;
        this._entryValue = initParams.entry_value;
        this._entryLowerThreshold = initParams.entry_lower_threshold;
        this._entryUpperThreshold = initParams.entry_upper_threshold;
        this._exitValue = initParams.exit_value;
        this._exitLowerThreshold = initParams.exit_lower_threshold;
        this._exitUpperThreshold = initParams.exit_upper_threshold;
    }
    set startTs(value) {
        console.error('Do not set objects this way');
    }
    setStartTs(value) {
        return this.dataService.updateAnomaly(this.id, { start_ts: value }, this);
    }
    get startTs() {
        return this._startTs;
    }
    set endTs(value) {
        console.error('Do not set objects this way');
    }
    setEndTs(value) {
        return this.dataService.updateAnomaly(this.id, { end_ts: value }, this);
    }
    get endTs() {
        return this._endTs;
    }
    set deviceId(value) {
        console.error('Do not set objects this way');
    }
    setDeviceId(value) {
        return this.dataService.updateAnomaly(this.id, { device_id: value }, this);
    }
    get deviceId() {
        return this._deviceId;
    }
    set deviceName(value) {
        console.error('Do not set objects this way');
    }
    setDeviceName(value) {
        return this.dataService.updateAnomaly(this.id, { device_name: value }, this);
    }
    get deviceName() {
        return this._deviceName;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    setSiteId(value) {
        return this.dataService.updateAnomaly(this.id, { site_id: value }, this);
    }
    get siteId() {
        return this._siteId;
    }
    set modelId(value) {
        console.error('Do not set objects this way');
    }
    setModelId(value) {
        return this.dataService.updateAnomaly(this.id, { model_id: value }, this);
    }
    get modelId() {
        return this._modelId;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    setSiteName(value) {
        return this.dataService.updateAnomaly(this.id, { site_name: value }, this);
    }
    get siteName() {
        return this._siteName;
    }
    set explanation(value) {
        console.error('Do not set objects this way');
    }
    setExplanation(value) {
        return this.dataService.updateAnomaly(this.id, { explanation: value }, this);
    }
    get explanation() {
        return this._explanation;
    }
    set notes(value) {
        console.error('Do not set objects this way');
    }
    setNotes(value) {
        return this.dataService.updateAnomaly(this.id, { notes: value }, this);
    }
    get notes() {
        return this._notes;
    }
    set userStatus(value) {
        console.error('Do not set objects this way');
    }
    setUserStatus(value) {
        return this.dataService.updateAnomaly(this.id, { user_status: value }, this);
    }
    get userStatus() {
        return this._userStatus;
    }
    set dismissed(value) {
        console.error('Do not set objects this way');
    }
    setDismissed(value) {
        return this.dataService.updateAnomaly(this.id, { dismissed: value }, this);
    }
    get dismissed() {
        return this._dismissed;
    }
    set invalid(value) {
        console.error('Do not set objects this way');
    }
    setInvalid(value) {
        return this.dataService.updateAnomaly(this.id, { invalid: value }, this);
    }
    get invalid() {
        return this._invalid;
    }
    set modelImageUrl(value) {
        console.error('Do not set objects this way');
    }
    setModelImageUrl(value) {
        return this.dataService.updateAnomaly(this.id, { model_image_url: value }, this);
    }
    get modelImageUrl() {
        return this._modelImageUrl;
    }
    set entryValue(value) {
        console.error('Do not set objects this way');
    }
    setEntryValue(value) {
        return this.dataService.updateAnomaly(this.id, { entry_value: value }, this);
    }
    get entryValue() {
        return this._entryValue;
    }
    set entryLowerThreshold(value) {
        console.error('Do not set objects this way');
    }
    setEntryLowerThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { entry_lower_threshold: value }, this);
    }
    get entryLowerThreshold() {
        return this._entryLowerThreshold;
    }
    set entryUpperThreshold(value) {
        console.error('Do not set objects this way');
    }
    setEntryUpperThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { entry_upper_threshold: value }, this);
    }
    get entryUpperThreshold() {
        return this._entryUpperThreshold;
    }
    set exitValue(value) {
        console.error('Do not set objects this way');
    }
    setExitValue(value) {
        return this.dataService.updateAnomaly(this.id, { exit_value: value }, this);
    }
    get exitValue() {
        return this._exitValue;
    }
    set exitLowerThreshold(value) {
        console.error('Do not set objects this way');
    }
    setExitLowerThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { exit_lower_threshold: value }, this);
    }
    get exitLowerThreshold() {
        return this._exitLowerThreshold;
    }
    set exitUpperThreshold(value) {
        console.error('Do not set objects this way');
    }
    setExitUpperThreshold(value) {
        return this.dataService.updateAnomaly(this.id, { exit_upper_threshold: value }, this);
    }
    get exitUpperThreshold() {
        return this._exitUpperThreshold;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateAnomaly(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = Anomaly;
//# sourceMappingURL=anomaly.js.map